module.exports = __webpack_public_path__ + "img/TRYB_TARMAC.a0179a30.png";